export const GET_DAILY_EVENT_START = 'GET_DAILY_EVENT_START';
export const GET_DAILY_EVENT_SUCCESS = 'GET_DAILY_EVENT_SUCCESS';
export const GET_DAILY_EVENT_ERROR = 'GET_DAILY_EVENT_ERROR';
